// ----------------------------------------------------------------------------
// Component: Fit & Value Prop
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';

// Style includes
import './_fit-value-prop.scss';